<template>
  <div class="overflow-x-auto">
    <div
      class="table-grid-row font-size-12 color-complementary-300 padding-x-16 margin-bottom-8 min-width-1200"
      :style="`grid-template-columns: repeat(${labels.length}, 1fr); grid-template-columns: ${generateColumnWidths};`"
    >
      <div
        class="width--max-content"
        v-for="({ label, isSortable }, index) in labels"
        :key="`a-${index}`"
      >
        <span class="">{{ label }}</span>
        <span v-if="isSortable" class="margin-right-8">
          <mdicon name="unfold-more-horizontal" size="16" />
        </span>
      </div>
    </div>
    <div class="table-body">
      <div
        v-for="(item, index) in items"
        :key="`b-${index}`"
        class="table-grid-row border--solid border--complementary-50 border-radius-8 margin-bottom-8 padding-16"
        :style="`grid-template-columns: repeat(${labels.length}, 1fr); grid-template-columns: ${generateColumnWidths};`"
      >
        <slot name="body-row" :item="item"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, toRefs } from "vue";
export default {
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    // generate props data
    const { labels, items } = toRefs(props);

    const generateColumnWidths = computed(() =>
      labels.value.map(({ width }) => width).join(" ")
    );
    // return data to be used in template
    return {
      labels,
      items,
      generateColumnWidths,
    };
  },
};
</script>
<style>
.table-grid-row {
  display: grid;
  grid-template-rows: auto;
  align-items: start;
}
.table-body {
  min-width: 1200px;
}
</style>
